const Lang = function (props) {
  return <>{props.isEn ? props.en : props.kr}</>;
};

export { Lang };
